import { computed, onBeforeMount, ref } from 'vue'
import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import FormInputDropdown from '../FormInputDropdown/FormInputDropdown.vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import StafetAddDeltager from '../StafetAddDeltager/StafetAddDeltager.vue'
import { useStore } from 'vuex'
import fieldsConfig from './config/fieldsConfig'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getFieldValue from 'foundation/js/stafet/getFieldValue'

export default {
    name: 'StafetDeltagPaaHoldStepSelectTeam',
    components: {
        FormInputTextField,
        FormInputDropdown,
        FormCheckbox,
        StafetActions,
        StafetAddDeltager
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const store = useStore()
        const teamName = ref('')
        const isFighter = ref(false)
        const shirtSize = ref('')
        const isFighterFreeLunch = ref(false)
        const isChild = ref(false)
        const addMoreParticipants = ref(false)
        const participants = ref({})

        const tshirtSizes = computed(() => {
            const array = []
            props.tshirtSizes.forEach((size) => {
                array.push({
                    name: size.displayName,
                    value: size.value
                })
            })
            return array
        })

        const teams = computed(() => {
            const array = []
            if (props.holdList) {
                props.holdList.forEach((hold) =>
                    array.push({ name: hold.name, value: hold.holdKode })
                )
            }

            return array
        })

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_JOIN_A_TEAM
            )
            if (storedFields) {
                updateLocalRefs([
                    {
                        name: 'teamName',
                        value: getFieldValue(storedFields, 'teamName')
                    },
                    {
                        name: 'isFighter',
                        value: getFieldValue(storedFields, 'isFighter')
                    },
                    {
                        name: 'shirtSize',
                        value: getFieldValue(storedFields, 'shirtSize')
                    },
                    {
                        name: 'isFighterFreeLunch',
                        value: getFieldValue(storedFields, 'isFighterFreeLunch')
                    },
                    {
                        name: 'isChild',
                        value: getFieldValue(storedFields, 'isChild')
                    }
                ])
            }

            if (props.holdId) {
                const holdExists = teams.value.some((t) => String(t.value) === String(props.holdId))
                if (holdExists) {
                    teamName.value = props.holdId
                    fieldsConfig.find((field) => field.name === 'teamName').value = props.holdId
                }
            }

            store.dispatch('donation/teams', { stafetId: props.stafetId })
            if (storedFields) {
                let adultParticipants = []
                let childParticipants = []

                if (getFieldValue(storedFields, 'deltagere')) {
                    adultParticipants = getFieldValue(storedFields, 'deltagere')
                }

                if (getFieldValue(storedFields, 'childDeltagere')) {
                    childParticipants = getFieldValue(
                        storedFields,
                        'childDeltagere'
                    )
                }

                participants.value.adults = adultParticipants
                participants.value.children = childParticipants

                const totalLength =
                    adultParticipants.length + childParticipants.length
                addMoreParticipants.value = totalLength > 0
            }
        })

        const updateLocalRefs = (fields) => {
            fields.forEach((field) => {
                if (field.value === undefined || field.value === null) return
                fieldsConfig.find((item) => item.name === field.name).value =
                    field.value
                switch (field.name) {
                    case 'teamName':
                        teamName.value = field.value
                        return
                    case 'isFighter':
                        isFighter.value = field.value
                        return
                    case 'shirtSize':
                        shirtSize.value = field.value
                        return
                    case 'isFighterFreeLunch':
                        isFighterFreeLunch.value = field.value
                        return
                    case 'isChild':
                        isChild.value = field.value
                        return
                    default:
                        return
                }
            })
        }

        const validateField = (fieldName, value) => {
            updateLocalRefs([{ name: fieldName, value: value }])
            const field = fieldsConfig.find((field) => field.name === fieldName)
            if (field) {
                if (field.dependentField) {
                    const dependentField = fieldsConfig.find(
                        (item) => item.name === field.dependentField
                    )

                    if (dependentField) {
                        field.dependentFieldValue = dependentField.value
                    }
                }

                field.value = value
                fieldValidator(field)
            }
        }

        const handleErrorMessage = (fieldName) => {
            const field = fieldsConfig.find((field) => field.name === fieldName)
            return !field?.isValid && props.displayInputError
        }

        const toggleAddMoreParticipants = (value) => {
            addMoreParticipants.value = value
        }

        const updateAddParticipants = (data) => {
            participants.value = data
        }

        const participantsStepModel = computed(() => {
            const result = []

            if (addMoreParticipants.value) {
                result.push({
                    name: 'deltagere',
                    value: participants.value.adults,
                    isValid: participants.value.isValid,
                    validator: () => participants.value.isValid
                })
                result.push({
                    name: 'childDeltagere',
                    value: participants.value.children,
                    isValid: participants.value.isValid,
                    validator: () => participants.value.isValid
                })
            }

            return result
        })

        const stepModel = computed(() => {
            return [...fieldsConfig, ...participantsStepModel.value]
        })

        return {
            teamName,
            isFighter,
            shirtSize,
            tshirtSizes,
            isFighterFreeLunch,
            isChild,
            teams,
            addMoreParticipants,
            participants,
            stepModel,
            validateField,
            handleErrorMessage,
            toggleAddMoreParticipants,
            updateAddParticipants
        }
    }
}
